module.exports = __webpack_public_path__ + "assets/Social-round-instagram.5fd1eedf.svg";